<div class="registration-supplementary-equipment" *ngIf="registration">

  <sc-flex [fitHeight]="true">
    <div class="options-list">
      <sc-flex [vertical]="true" [stretchContent]="true">
        <mat-form-field *ngIf="cps.isEnabled('visitoverview.register.messagingLanguage', false)" appearance="fill">
          <mat-label>
            {{'messaging language' | translate: ['tmc.transport.registration.messagingLanguage',
            translationService.language]}}
          </mat-label>
          <mat-select name="messagingLanguage" [(ngModel)]="registration.transport.messaging.messagingLanguage"
            #messagingLanguageType="ngModel" [required]="true">
            <mat-option *ngFor="let o of getMessagingLanguagesOrdererByCurrentTranslation()"
              value="{{o}}">
              {{o | translate: ['common.enum.language.' + o, translationService.language]}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="form-checkbox">
          <div class="checkbox-label">
            <mat-checkbox class="col first" name="useGlobalConnect" [(ngModel)]="registration.transport.messaging.useGlobalConnect"
              #useGlobalConnect="ngModel">
              {{'use Global Connect' | translate: ['tmc-yard.entity.transport.messaging.useGlobalConnect',
              translationService.language]}}
            </mat-checkbox>
          </div>
        </div>
        <div class="form-checkbox">
          <div class="checkbox-label">
            <mat-checkbox *ngIf="cps.isEnabled('feature.sms', false)" class="col first" name="useSms" [(ngModel)]="registration.transport.messaging.useSms"
              #useGlobalConnect="ngModel">
              {{'use SMS' | translate: ['tmc-yard.entity.transport.messaging.useSms',
              translationService.language]}}
            </mat-checkbox>
          </div>
        </div>
      </sc-flex>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="options-list no-field-space"
      *ngIf="(registration.registerNow || registration.transport.timing.planningType !== planningType.IN_ADVANCE) && !cps.isEnabled('ui-component.register-transport.supplementary-equipment.hidden', false)">
      <sc-flex [vertical]="true" [stretchContent]="true">
        <div class="form-checkbox no-supplementary-cbx"
          *ngIf="cps.isEnabled(clientParameters.FEATURE_FORCE_SUPPLEMENTARY_EQUIPMENT_CONFIRMATION, true)">
          <div class="checkbox-label">
            <mat-checkbox [(ngModel)]="registration.noSupplementaryEquipmentHandout"
              [ngModelOptions]="{standalone: true}" [disabled]="isNoSupplementaryEquipmentHandoutDisabled()">
              {{'no supplementary equipment handout' | translate:
              ['tmc.transport.registration.supplementaryEquipment.nosupplementaryequipmenthandout',
              translationService.language]}}
            </mat-checkbox>
          </div>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div *ngFor="let se of registration.supplementaryEquipments">
          <sc-flex >
            <div class="checkbox-label">
              <mat-checkbox [(ngModel)]="se.selected" [ngModelOptions]="{standalone: true}"
                [disabled]="isNoSupplementaryEquipmentHandoutSelected()">
                {{se.dictionaryKey | translate:[se.dictionaryKey, translationService.language]}}
              </mat-checkbox>
            </div>
            <sc-content-spacer></sc-content-spacer>
            <mat-form-field class="checkbox-value" *ngIf="isStringParameter(se)">
              <input class="value-input" matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: true}"
                required [disabled]="!se.selected"
                placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
            </mat-form-field>
            <sc-content-spacer></sc-content-spacer>
            <mat-form-field class="checkbox-value" *ngIf="isNumberParameter(se)">
              <input class="value-input" [type]="'number'" matInput [(ngModel)]="se.parameter1Value"
                [ngModelOptions]="{standalone: true}" required [disabled]="!se.selected"
                placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
            </mat-form-field>
          </sc-flex>
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
        </div>

      </sc-flex>
    </div>
  </sc-flex>



  <!-- Keine Begleitmittelausgabe für Vorabanmeldungen "wenn nicht jetzt einbuchen"-->

</div>